// extracted by mini-css-extract-plugin
export default {"cls1":"PostImage-cls1___046b29a9b407174ec9c","cls2":"PostImage-cls2__dd0fdd974c74348ae7c7 PostImage-cls1___046b29a9b407174ec9c","border":"PostImage-border___07a50361f88a696b231"};